var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 67,
    viewBox: "0 0 69 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.0702,
    cy: 33.5,
    rx: 34.0702,
    ry: 33.5,
    fill: "#C4C4C4",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0001 22C37.3151 22 40.0001 24.6401 40.0001 27.8996C40.0001 31.1591 37.3151 33.7992 34.0001 33.7992C30.6851 33.7992 28.0001 31.1591 28.0001 27.8996C28.0001 24.6401 30.6851 22 34.0001 22ZM34.0001 45.5983C34.0001 45.5983 46.0001 45.5983 46.0001 42.6485C46.0001 39.1088 40.1501 35.2741 34.0001 35.2741C27.8501 35.2741 22.0001 39.1088 22.0001 42.6485C22.0001 45.5983 34.0001 45.5983 34.0001 45.5983Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.225c241699e9e325d9200c883e1af7f9.svg";
export { ForwardRef as ReactComponent };